// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"295a09d0","453":"ca5c3f6d","455":"6e369eec","977":"12d9407a"}[chunkId] + ".chunk.js";
};